import { Divider, ToggleButton, ToggleButtonGroup } from "@mui/material";
import classes from "../ToggleButtons.module.css";
import CustomIcon from "../../../CustomIcons/CustomIcon";
import { FOB_ASSIGN_OPTIONS } from "../../../../../constants/Constants";
import SelectedTokenCard from "../../../Cards/SelectedTokenCard/SelectedTokenCard";
import Strings from "../../../../../resources/Strings";

const AssigneFobToggleButtons = (props) => {
  return (
    <div className={classes.customToggleButtons}>
      {!props.isFobSkipped && <SelectedTokenCard
        text={props.skipFob ? Strings.FOB_SKIPPED : `${Strings.SCAN_FOB_SUCCESS}: ${props.fobId}`}
        handleDelete={props.handleDeleteFob}
      />}
      <Divider />
      <div className={classes.message}>
        {Strings.ASSIGN_SUGGEST}
      </div>
      <ToggleButtonGroup
        color="primary"
        value={props.selectedOption}
        exclusive
        onChange={props.handleChange}
        className={`${classes.group} ${classes.center}`}
      >
        {FOB_ASSIGN_OPTIONS.map((option) => {
          return (
            <ToggleButton
              key={option.id}
              className={classes.assignOption}
              value={option.id}
            >
              <CustomIcon img={option.icon} />
              <span className={classes.label}>{option.label}</span>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
};

export default AssigneFobToggleButtons;
